import { useMemo } from 'react';
import type { MyUserViewModel, UserModel } from 'core/services';
import type { BaseEntity, PaginationResponse } from 'core/base';
import type { DocumentAccessManager } from 'core/hooks';
import type { RowData } from '../types';
import { moveUserToFront } from '../utils';

export const useDataSource = (
  document: BaseEntity | undefined,
  user: MyUserViewModel | null,
  users?: PaginationResponse<UserModel>,
  accessManager?: DocumentAccessManager,
) => {
  return useMemo<RowData[] | undefined>(() => {
    if (!users) return;

    if (document) {
      const list = users.items.map(user => {
        const access = accessManager?.getForUser(user.id);
        const role = access ? access.roles[0] : document.published ? 'guest' : null;
        return {
          id: user.id,
          email: user.email,
          firstName: user.firstName,
          role,
        };
      });
      return user ? moveUserToFront(user, list) : list;
    }

    const list = users.items.map(user => {
      return {
        id: user.id,
        email: user.email,
        firstName: user.firstName,
        role: user.roles?.[0],
      };
    });
    return user ? moveUserToFront(user, list) : list;
  }, [users, accessManager]);
};
